import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { PanelMenuModule } from 'primeng/panelmenu';
import { SidebarModule } from 'primeng/sidebar';
import { FooterModule } from '../../components/footer/footer.module';
import { HeaderModule } from '../../components/header/header.module';
import { MainLayoutComponent } from '../../components/main-layout/main-layout.component';
import { MenuModule } from '../../components/menu/menu.module';
import { SideMenuModule } from '../side-menu/side-menu.module';

const PRIMENG_MODULES = [PanelMenuModule, SidebarModule, BreadcrumbModule];
@NgModule({
  declarations: [MainLayoutComponent],
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule,
    HeaderModule,
    FooterModule,
    MenuModule,
    SideMenuModule,
    ...PRIMENG_MODULES,
  ],
  exports: [MainLayoutComponent],
})
export class MainLayoutModule {}
